module.exports = __webpack_public_path__ + "img/5.ebb22ba8.jpg";